import React from 'react';

type Props = React.SVGProps<SVGSVGElement> & { className?: string };

const BoatIcon: React.FC<Props> = ({ className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    className={className}
    {...props}
  >
    {/* Mast */}
    <path d="M12 3v10" strokeLinecap="round" />
    {/* Sail */}
    <path d="M12 4l6 6-6 2V4z" strokeLinecap="round" strokeLinejoin="round" />
    {/* Hull */}
    <path d="M3 16l2 3h14l2-3H3z" strokeLinecap="round" strokeLinejoin="round" />
    {/* Waves */}
    <path d="M4 20c1 .8 2 .8 3 0 1 .8 2 .8 3 0 1 .8 2 .8 3 0 1 .8 2 .8 3 0" strokeLinecap="round" />
  </svg>
);

export default BoatIcon;